import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumGetUserByCredentialStatus implements BaseEnumType {
  private static allValues: EnumGetUserByCredentialStatus[] = []; // make sure this is top-most
  
  public static ok = new EnumGetUserByCredentialStatus(0, "Ok", "enum_get_user_by_credential_status_ok");
  public static badEmail = new EnumGetUserByCredentialStatus(1, "BadEmail", "enum_get_user_by_credential_status_bad_email");
  public static badPassword = new EnumGetUserByCredentialStatus(2, "BadPassword", "enum_get_user_by_credential_status_bad_password");
  public static disabled = new EnumGetUserByCredentialStatus(3, "Disabled", "enum_get_user_by_credential_status_disabled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumGetUserByCredentialStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOk() { return this === EnumGetUserByCredentialStatus.ok; }
  public isBadEmail() { return this === EnumGetUserByCredentialStatus.badEmail; }
  public isBadPassword() { return this === EnumGetUserByCredentialStatus.badPassword; }
  public isDisabled() { return this === EnumGetUserByCredentialStatus.disabled; }

  public static getValues(): readonly EnumGetUserByCredentialStatus[] {
    return EnumGetUserByCredentialStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumGetUserByCredentialStatus[] {
    return EnumGetUserByCredentialStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumGetUserByCredentialStatus {
    const found = EnumGetUserByCredentialStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumGetUserByCredentialStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumGetUserByCredentialStatus): EnumGetUserByCredentialStatus {
    const found = name ? EnumGetUserByCredentialStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumGetUserByCredentialStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumGetUserByCredentialStatus>): boolean {
    return this.key === other?.key;
  }
}